<template>

    <m-edit1/>

    <m-shopping-cart-3 v-bind='{...{"EmptyCartImage":null,"instagram":false,"presenterProp":false,"addressName":false,"codeMeliProp":false,"gradeProp":false,"orientationProp":false,"schoolNameProp":false,"classNameProp":false,"birthdayProp":false,"motherJobProp":false,"fatherJobProp":false,"registerRequestProp":false,"gradeSelectProp":false,"roundTripServiceProp":false,"shiftProp":false,"showWalletChargeProp":true,"showWalletGate":true,"advanceDescriptionInputs":"","advanceDescription":false,"defaultGate":"","enableEditOrder":false},...{}}' :style='"margin-top:120px;"' class="my-5 py-5" ></m-shopping-cart-3>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mShoppingCart3 from '@moeinmdn/miw-alpha-components/src/package/ShoppingCart/ShoppingCart3';

export default {
    name: 'HomeView',
    components: {mEdit1, mShoppingCart3 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
